import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { useTags } from "../data";

const TagSelect = ({ value, onChange, isNew, selected=[] }) => {
  const { isSafe, data } = useTags();
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const tagSelected = selected.map(item => item.tag.id);

  const tagElements = data.filter(item => {
    if(!isNew){
      return true;
    } else {
      return !tagSelected.includes(item.id);
    }
  }).map(tag => {
    return (
      <MenuItem value={tag.id} key={tag.id}>
        {tag.name}
      </MenuItem>
    );
  });

  return (
    <FormControl variant="outlined" disabled={!isSafe || !isNew} fullWidth>
      <InputLabel ref={inputLabel} id="tag">
        Etiqueta
      </InputLabel>
      <Select
        labelId="select-outlined-label"
        id="tag"
        name="tag"
        value={value}
        onChange={onChange}
        labelWidth={labelWidth}
        fullWidth
      >
        <MenuItem value="">
          <em>Seleccionar</em>
        </MenuItem>
        {tagElements}
      </Select>
    </FormControl>
  );
};

export default TagSelect;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-item/tag-select.js